import styled from "@emotion/styled";
import { space } from "metabase/styled-components/theme";

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CacheFieldContainer = styled.div`
  margin-left: ${space(2)};
`;
